import { takeEvery } from 'redux-saga';
import { put } from 'redux-saga/effects';
import { FCH_PERSON_ID, GENDER_FIELD_NAME, FIELD_RELATION, FCH_COMPONENT_PATH, DATA_PATH, NAME_FIELD_NAME,
        PERSONS_ARRAY_FIELDS, relativesDescription, UPDATE_PERSON_RELATION,
        updateFCHField, removeRelative, getRelationNameFromFieldName
} from './reducer.jsx';
import { setFieldValue, SET_FIELD_VALUE, RESET_FIELD_VALUE } from '../../app.reducer.jsx';
import { store } from '../../app.store.jsx';

export function* emitGenderUpdate(action) {
    const { internalId, relation: newRelation } = action;

    const person = store.getState().components.getIn([ FCH_COMPONENT_PATH, internalId ]);
    const personId = person.get(FCH_PERSON_ID);
    const currentPersonRelation = person.get(FIELD_RELATION);

    const isFromPersonsArray = currentPersonRelation in PERSONS_ARRAY_FIELDS;
    const isToPersonsArray = newRelation in PERSONS_ARRAY_FIELDS;
    const movingThroughArrays = isFromPersonsArray && isToPersonsArray;

    const currentRelationDesc = relativesDescription[currentPersonRelation] || {};
    const newRelationDesc = relativesDescription[newRelation] || {};

    const currentRelationGender = currentRelationDesc.gender;
    const newRelationGender = newRelationDesc.gender;

    const sameRelation = newRelation === currentPersonRelation;
    const differentGender = currentRelationGender !== newRelationGender;

    if (movingThroughArrays && sameRelation && differentGender) {
        yield put(setFieldValue(GENDER_FIELD_NAME, newRelationGender, `${newRelationDesc.field} ${DATA_PATH} ${personId}`));
    }
}

const SINGLE_PERSON_FIELD_NAMES = new Set([
    'mother', 'father', 'maternal_grandmother', 'maternal_grandfather', 'paternal_grandmother', 'maternal_grandmother'
]);

const PERSONS_ARRAY_FIELD_NAMES = new Set([
    'siblings', 'children', 'mother_siblings', 'father_siblings', 'cousins', 'nephews'
]);

const SINGLE_SPACE = ' ';
const MALE = 'MALE';
const FEMALE = 'FEMALE';

function getComponents() {
    return store.getState().components.get(FCH_COMPONENT_PATH);
}

export function* listenToPersonsUpdates(action) {
    const { root, name, value } = action;

    if (undefined === root) { return null; }
    const LISTENED_FIELDS = new Set([ GENDER_FIELD_NAME, NAME_FIELD_NAME ]);
    if (!LISTENED_FIELDS.has(name)) { return null; }

    let fieldName = name,
        personId = null;
    const splitedName = root.split(SINGLE_SPACE);
    //root: 'siblings data 1'
    const PERSONS_ARRAY_ROOT_LENGTH = 3;
    if (PERSONS_ARRAY_ROOT_LENGTH === splitedName.length) { [ fieldName, , personId ] = splitedName; }
    const personsList = getComponents();
    if ((null === personId) && (SINGLE_PERSON_FIELD_NAMES.has(fieldName)) && NAME_FIELD_NAME === fieldName) {
        const internalId = personsList.findIndex((person) => {
            return person.get(FIELD_RELATION) === fieldName;
        });
        if (undefined === internalId) { return null; }
        yield put(updateFCHField(internalId, NAME_FIELD_NAME, value));
    } else if ((null !== personId) && (PERSONS_ARRAY_FIELD_NAMES.has(fieldName))) {
        const personRelation = getRelationNameFromFieldName(fieldName, MALE); //In this case gender doesn't matters
        const internalId = personsList.findIndex((person) => {
            return (person.get(FCH_PERSON_ID) === String(personId)) && (person.get(FIELD_RELATION) === personRelation);
        });
        if (-1 === internalId) { return null; }
        if (NAME_FIELD_NAME === name) {
            yield put(updateFCHField(internalId, NAME_FIELD_NAME, value));
        } else if (GENDER_FIELD_NAME === name) {
            const newRelationValue = getRelationNameFromFieldName(fieldName, value);
            yield put(updateFCHField(internalId, FIELD_RELATION, newRelationValue));
        }
    }
}

export function* listenForPersonRemove(action) {
    const { root, name } = action;
    if (undefined === root) { return null; }

    const splitedValue = root.split(SINGLE_SPACE);
    const PERSONS_ARRAY_ROOT_LENGTH = 2;
    if (PERSONS_ARRAY_ROOT_LENGTH !== splitedValue.length) { return null; }
    let fieldName = splitedValue[0];

    const components = getComponents();
    const maleRelationName = getRelationNameFromFieldName(fieldName, MALE);
    const femaleRelationName = getRelationNameFromFieldName(fieldName, FEMALE);
    const removedPersonIndex = components.findIndex((person) => {
        const relationName = person.get(FIELD_RELATION);
        const relationMatch = (relationName === maleRelationName) || (relationName === femaleRelationName);
        return relationMatch && (person.get(FCH_PERSON_ID) === String(name));
    });

    if (-1 === removedPersonIndex) { return null; }
    yield put(removeRelative(removedPersonIndex));
}

export default function* identicalGroupUpdateSaga() {
    yield [
        takeEvery(UPDATE_PERSON_RELATION, emitGenderUpdate),
        takeEvery(SET_FIELD_VALUE, listenToPersonsUpdates),
        takeEvery(RESET_FIELD_VALUE, listenForPersonRemove)
    ];
}
